import { toast } from "./Toasts";

(function attach() {
  if (typeof window === "undefined") return;
  if (window.__toastFetchPatched) return;
  const originalFetch = window.fetch.bind(window);
  window.fetch = async function(input, init = {}) {
    let req = input;
    let options = init || {};
    let method = (
      options.method ||
      (typeof input === "object" && input.method) ||
      "GET"
    ).toUpperCase();

    try {
      const response = await originalFetch(input, init);

      let skip = false;
      try {
        const reqHeaders = new Headers(
          options.headers || (typeof req === "object" && req.headers) || {}
        );
        skip = reqHeaders.get("X-Toast-Handled") === "1";
      } catch (e) {
        console.error("Error getting toast header", e);
      }

      if (!skip) {
        if (!response.ok) {
          const cloned = response.clone();
          let message = `${method} ${
            typeof input === "string" ? input : (input && input.url) || ""
          } failed (${response.status})`;
          try {
            const data = await cloned.json();
            message = (data && (data.error || data.message)) || message;
          } catch (e) {
            console.error("Error parsing JSON response", e);
          }
          if (response.status !== 401) {
            toast.error(message);
          }
        } else if (["POST", "PUT", "DELETE", "PATCH"].includes(method)) {
          try {
            const data = await response.clone().json();
            const message =
              (data && (data.message || data.status)) || "Endringer lagret";
            toast.success(message);
          } catch (e) {
            toast.success("Endringer lagret");
          }
        }
      }

      return response;
    } catch (err) {
      toast.error(`Network error: ${err && err.message ? err.message : err}`);
      throw err;
    }
  };
  window.__toastFetchPatched = true;
})();
